import createEvaluationsHook from './createEvaluationsHook';

export default createEvaluationsHook('evaluationEventPartner', 'event', { completed: true });
